import React from "react";
import { useRouteError } from "react-router-dom";
import Bugsnag from "@bugsnag/js";
import { errorLog } from "./utils/logger";
import { useTranslation } from "react-i18next";

export function ErrorPage() {
  const { t } = useTranslation();
  const error: any = useRouteError();
  errorLog(error as Error);
  Bugsnag.notify(error);

  const errorImg = "/assets/images/error_centered.png";

  return (
    <div
      id="error-page"
      data-testid="static-error-page"
      className="flex items-center justify-center h-screen"
      style={{
        backgroundImage: `url(${errorImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="text-center text-lg mt-42 w-64 max-w-screen rounded-box">
        <p>Docket wasn't immunized against this unknown error.</p>
        <p className="mt-2">Please refresh the page or restart the app.</p>
      </div>
    </div>
  );
}

export default ErrorPage;
